// extracted by mini-css-extract-plugin
export default {"wrapper":"CheckBubble_wrapper__9Sxti"};